// import "./profile.css";
import useCopyToClipboard from "../../assets/hooks/useCopyToClipboard";
import useProtectedRoute from "../../assets/hooks/useProtectedRoute";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ar, en } from "../../assets/langs/translation";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import server from "../../assets/axios/server";
import { useParams } from "react-router-dom";
import trainerBanner from "../../assets/images/profile/trainerBanner.png";

const Trainer = () => {
  const { copyToClipboard } = useCopyToClipboard();
  const [trainerData, setTrainerData] = useState([]);
  const { trainerID } = useParams();

  // feach trainer data from
  useEffect(() => {
    server
      .get(`/trainer-requests/${trainerID}`)
      .then((res) => {
        setTrainerData(res.data.data);
        console.log(res.data.data);
      })
      .catch((err) => console.log(err));
  }, [server]);

  // to set lang
  const { lang } = useSelector((state) => state.settings);
  const currentLang = lang === "en" ? en : ar;

  return (
    <main className="container mx-auto lg:max-w-[1060px] flex flex-col items-center justify-center px-[5px] sm:px-0 mb-[50px] mt-[20px]">
      <div
        className="w-full pb-[clamp(180px,17.36111111111111vw,250px)] border border-[#F1F1F2] overflow-hidden rounded-[30px]"
        style={{ boxShadow: " 0px 3px 4px 0px #00000008" }}
      >
        {/* user images */}
        <div className="w-full rounded-[12px] h-[clamp(130px,11.041666666666666vw,212px)] relative">
          <img
            className="w-full h-full rounded-[12px]"
            src={trainerBanner}
            alt="academyCover"
            loading="lazy"
          />
          <div className="absolute top-[60%] sm:top-[50%]  inset-x-[50%] translate-x-[50%] flex flex-col items-center justify-center w-full sm:w-fit">
            <div
              className=" w-[clamp(100px,10.625vw,204px)] h-[clamp(100px,10.625vw,204px)] rounded-full bg-[#fff]  p-[7px] "
              style={{ boxShadow: "0px 3px 4px 0px #00000008" }}
            >
              <img
                className="w-full h-full rounded-full"
                src={
                  trainerData?.image ||
                  "https://via.assets.so/img.jpg?w=800&h=800&tc=blue&bg=#C4C4C4"
                }
                alt="avatar"
                loading="lazy"
              />
            </div>

            {/* user info */}
            <div className="w-fit flex items-center justify-center flex-col gap-[8px] mt-[clamp(10px,1.0416vw,20px)]">
              <h2 className="font-[Cairo] text-nowrap text-[clamp(14px,1.3888888888888888vw,20px)] font-[700] leading-[clamp(14px,1.09375vw,21px)] text-[#000]">
                {trainerData?.name}
              </h2>
              <div className="flex items-center justify-start gap-[5px]">
                <span className="font-[Cairo] text-[clamp(9px,0.57291vw,11px)] font-[600] leading-[clamp(14px, 1.041vw,20px)] text-[#B0B0B0]">
                  {trainerData?.job_title}
                </span>
              </div>
            </div>
          </div>

          {/* user social */}
          <div className="w-full flex items-center justify-center gap-[8px] sm:justify-between px-[10px] mt-[clamp(120px,9.7222223vw,140px)] sm:mt-[10px]  ">
            <div className=" flex items-center gap-[8px]">
              {/* instagram */}
              <a
                href={trainerData.instagram || "https://instagram.com"}
                target="_blank"
                className="w-[44px] h-[clamp(35px,2.291vw,44px)] flex items-center justify-center rounded-[8px] "
                style={{
                  background:
                    "linear-gradient(45deg, #FAAD4F 14.61%, #DD2A7B 39.38%, #9537B0 58.49%, #515BD4 85.39%)",
                  backgroundPosition: "center center",
                  boxShadow: "0px 3px 4px 0px #00000008",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.8444 0.716187H5.16044C2.48507 0.716187 0.308594 2.8933 0.308594 5.56946V14.4315C0.308594 17.1076 2.48507 19.2847 5.16044 19.2847H14.8444C17.5197 19.2847 19.6962 17.1076 19.6962 14.4315V5.56946C19.6962 2.8933 17.5197 0.716187 14.8444 0.716187ZM2.02017 5.56946C2.02017 3.83764 3.42912 2.42827 5.16044 2.42827H14.8444C16.5757 2.42827 17.9846 3.83764 17.9846 5.56946V14.4315C17.9846 16.1633 16.5757 17.5727 14.8444 17.5727H5.16044C3.42912 17.5727 2.02017 16.1633 2.02017 14.4315V5.56946Z"
                    fill="white"
                  />
                  <path
                    d="M10.0033 14.5137C12.4911 14.5137 14.5163 12.4891 14.5163 9.99935C14.5163 7.50965 12.4922 5.48499 10.0033 5.48499C7.51431 5.48499 5.49023 7.50965 5.49023 9.99935C5.49023 12.4891 7.51431 14.5137 10.0033 14.5137ZM10.0033 7.19816C11.5482 7.19816 12.8047 8.45508 12.8047 10.0004C12.8047 11.5458 11.5482 12.8027 10.0033 12.8027C8.45836 12.8027 7.20181 11.5458 7.20181 10.0004C7.20181 8.45508 8.45836 7.19816 10.0033 7.19816Z"
                    fill="white"
                  />
                  <path
                    d="M14.9328 6.21441C15.6027 6.21441 16.1487 5.6693 16.1487 4.99807C16.1487 4.32684 15.6038 3.78174 14.9328 3.78174C14.2617 3.78174 13.7168 4.32684 13.7168 4.99807C13.7168 5.6693 14.2617 6.21441 14.9328 6.21441Z"
                    fill="white"
                  />
                </svg>
              </a>

              {/* facebook */}
              <a
                href={trainerData.facebook || "https://facebook.com"}
                target="_blank"
                className="w-[44px] h-[clamp(35px,2.291vw,44px)] flex items-center justify-center rounded-[8px] bg-[#1877F2] "
                style={{
                  boxShadow: "0px 3px 4px 0px #00000008",
                }}
              >
                <svg
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.80117 4.50662V7.32631H11.2883L10.7361 11.1246H7.80117V19.8757C7.21273 19.9574 6.6107 20 5.9996 20C5.2942 20 4.6015 19.9438 3.92693 19.8349V11.1246H0.710938V7.32631H3.92693V3.87629C3.92693 1.73589 5.66141 0 7.80208 0V0.00181359C7.80842 0.00181359 7.81386 0 7.82021 0H11.2892V3.28496H9.02247C8.3488 3.28496 7.80208 3.83185 7.80208 4.50571L7.80117 4.50662Z"
                    fill="white"
                  />
                </svg>
              </a>

              {/* whatsapp */}
              <a
                href={
                  `https://wa.me/${trainerData?.whatsapp_number}` ||
                  "https://wa.me/4915252455276"
                }
                target="_blank"
                className="w-[clamp(140px,8.69791vw,167px)] h-[clamp(35px,2.291vw,44px)] flex items-center justify-center gap-[5px] rounded-[8px] bg-[#28AF60] "
                style={{
                  boxShadow: "0px 3px 4px 0px #00000008",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2596 0.880136C10.3258 0.471247 10.7124 0.193872 11.1212 0.26007C11.1466 0.264914 11.228 0.280135 11.2707 0.289637C11.356 0.308641 11.475 0.337899 11.6234 0.381124C11.9202 0.467567 12.3348 0.609972 12.8324 0.838108C13.8287 1.29486 15.1545 2.09387 16.5303 3.46967C17.9061 4.84547 18.7051 6.17128 19.1619 7.16756C19.39 7.66517 19.5324 8.07978 19.6188 8.37656C19.6621 8.52496 19.6913 8.64399 19.7103 8.72932C19.7198 8.77199 19.7268 8.80625 19.7316 8.83156L19.7374 8.86275C19.8036 9.27164 19.5287 9.67416 19.1198 9.74036C18.7121 9.80637 18.328 9.53033 18.2602 9.12336C18.2581 9.11244 18.2524 9.08308 18.2462 9.05539C18.2339 9.00001 18.2125 8.91218 18.1787 8.79603C18.111 8.56369 17.9935 8.21836 17.7983 7.79268C17.4085 6.94238 16.7075 5.76819 15.4696 4.53033C14.2318 3.29247 13.0576 2.59147 12.2073 2.20164C11.7816 2.00648 11.4363 1.88895 11.2039 1.82128C11.0878 1.78745 10.9418 1.75394 10.8864 1.7416C10.4794 1.67378 10.1936 1.28786 10.2596 0.880136Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.4859 4.3296C10.5997 3.93133 11.0148 3.70071 11.413 3.8145L11.207 4.53564C11.413 3.8145 11.413 3.8145 11.413 3.8145L11.4145 3.81491L11.416 3.81536L11.4194 3.81633L11.4271 3.81864L11.4469 3.82481C11.462 3.82963 11.4808 3.83591 11.5033 3.84388C11.5482 3.85981 11.6075 3.88248 11.6803 3.91368C11.826 3.97612 12.0251 4.07254 12.2696 4.21725C12.7591 4.50693 13.4272 4.98811 14.2122 5.77308C14.9972 6.55805 15.4784 7.22624 15.768 7.7157C15.9128 7.96021 16.0092 8.15928 16.0716 8.30496C16.1028 8.37777 16.1255 8.43713 16.1414 8.48204C16.1494 8.50449 16.1557 8.52332 16.1605 8.5384L16.1666 8.55818L16.169 8.56594L16.1699 8.56927L16.1704 8.5708C16.1704 8.5708 16.1708 8.57224 15.4496 8.77828L16.1708 8.57224C16.2846 8.97052 16.054 9.38563 15.6557 9.49943C15.2608 9.61225 14.8493 9.38649 14.7315 8.99443L14.7278 8.98365C14.7224 8.96863 14.7114 8.93904 14.6929 8.89584C14.6559 8.80951 14.5888 8.66827 14.4772 8.47968C14.2542 8.10294 13.8515 7.53369 13.1516 6.83374C12.4516 6.13379 11.8823 5.73108 11.5056 5.50811C11.317 5.3965 11.1758 5.3294 11.0894 5.2924C11.0462 5.27388 11.0167 5.26285 11.0016 5.25752L10.9909 5.25382C10.5988 5.13594 10.373 4.7245 10.4859 4.3296Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.00745 3.4069C3.68752 1.72683 6.52266 1.85455 7.69248 3.95067L8.34149 5.1136C9.10541 6.48242 8.77987 8.2095 7.66157 9.34147C7.64668 9.36188 7.56774 9.47681 7.55791 9.67762C7.54536 9.93394 7.63639 10.5267 8.55482 11.4452C9.47295 12.3633 10.0656 12.4545 10.3221 12.4421C10.5231 12.4323 10.6381 12.3533 10.6585 12.3384C11.7905 11.2201 13.5176 10.8946 14.8864 11.6585L16.0493 12.3075C18.1454 13.4773 18.2731 16.3125 16.5931 17.9925C15.6944 18.8912 14.4995 19.6897 13.0953 19.7429C11.0144 19.8218 7.55913 19.2844 4.13735 15.8626C0.715564 12.4408 0.178177 8.9856 0.257065 6.90467C0.310297 5.50048 1.10879 4.30556 2.00745 3.4069ZM6.38265 4.68167C5.78363 3.60832 4.17394 3.36173 3.06811 4.46756C2.29276 5.24291 1.7887 6.09872 1.75599 6.9615C1.6902 8.69684 2.11864 11.7226 5.19801 14.802C8.27737 17.8813 11.3031 18.3098 13.0385 18.244C13.9013 18.2113 14.7571 17.7072 15.5324 16.9319C16.6382 15.826 16.3916 14.2163 15.3183 13.6173L14.1554 12.9683C13.432 12.5646 12.4158 12.7023 11.7025 13.4156C11.6325 13.4856 11.1864 13.9018 10.395 13.9403C9.58474 13.9797 8.604 13.6157 7.49416 12.5058C6.38395 11.3956 6.02003 10.4146 6.0597 9.60427C6.09846 8.81275 6.51468 8.36715 6.58432 8.2975C7.29764 7.58418 7.43539 6.56801 7.03166 5.8446L6.38265 4.68167Z"
                    fill="white"
                  />
                </svg>
                <span className="font-[Cairo] text-[clamp(10px,0.625vw,12px)] font-[600] leading-[clamp(15px,1.1458vw,22px)] text-[#fff]">
                  {currentLang.contactInstitutions}
                </span>
              </a>
            </div>

            {/* share */}
            <div>
              <div
                onClick={() => {
                  copyToClipboard(window.location.href);
                  toast.success("Link copied to clipboard");
                }}
                className="w-[66px] h-[clamp(35px,2.291vw,44px)] flex items-center justify-center rounded-[8px] border border-[#28AF6080] "
                style={{
                  boxShadow: "0px 3px 4px 0px #00000008",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 12C9 13.3807 7.88071 14.5 6.5 14.5C5.11929 14.5 4 13.3807 4 12C4 10.6193 5.11929 9.5 6.5 9.5C7.88071 9.5 9 10.6193 9 12Z"
                    stroke="#44A853"
                    stroke-width="1.5"
                  />
                  <path
                    d="M14 6.5L9 10"
                    stroke="#44A853"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M14 17.5L9 14"
                    stroke="#44A853"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M19 18.5C19 19.8807 17.8807 21 16.5 21C15.1193 21 14 19.8807 14 18.5C14 17.1193 15.1193 16 16.5 16C17.8807 16 19 17.1193 19 18.5Z"
                    stroke="#44A853"
                    stroke-width="1.5"
                  />
                  <path
                    d="M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5Z"
                    stroke="#44A853"
                    stroke-width="1.5"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* information */}
      <div className="flex w-full flex-col sm:flex-row gap-[15px] mt-[15px] items-start justify-start  ">
        <div className="main-shadow flex flex-col w-full sm:!w-[250px] border border-[#F1F1F2] p-[13px] rounded-[20px] gap-[10px] ">
          <div className="flex items-center justify-start gap-[10px]">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9 6.25C7.48122 6.25 6.25 7.48122 6.25 9C6.25 10.5188 7.48122 11.75 9 11.75C10.5188 11.75 11.75 10.5188 11.75 9C11.75 7.48122 10.5188 6.25 9 6.25ZM7.75 9C7.75 8.30965 8.30965 7.75 9 7.75C9.69036 7.75 10.25 8.30965 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30965 10.25 7.75 9.69036 7.75 9Z"
                fill="#28AF60"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9 12.25C7.80424 12.25 6.68461 12.4907 5.83616 12.915C5.03258 13.3168 4.25 14.0106 4.25 15L4.24987 15.0625C4.24834 15.5728 4.24576 16.4322 5.06023 17.0218C5.43818 17.2953 5.9369 17.4698 6.55469 17.581C7.1782 17.6932 7.97721 17.75 9 17.75C10.0228 17.75 10.8218 17.6932 11.4453 17.581C12.0631 17.4698 12.5618 17.2953 12.9398 17.0218C13.7542 16.4322 13.7517 15.5728 13.7501 15.0625L13.75 15C13.75 14.0106 12.9674 13.3168 12.1638 12.915C11.3154 12.4907 10.1958 12.25 9 12.25ZM5.75 15C5.75 14.8848 5.86285 14.5787 6.50698 14.2566C7.10625 13.957 7.98662 13.75 9 13.75C10.0134 13.75 10.8937 13.957 11.493 14.2566C12.1371 14.5787 12.25 14.8848 12.25 15C12.25 15.6045 12.2115 15.6972 12.0602 15.8067C11.9382 15.895 11.6869 16.0134 11.1797 16.1047C10.6782 16.1949 9.97721 16.25 9 16.25C8.02279 16.25 7.3218 16.1949 6.82031 16.1047C6.31311 16.0134 6.06182 15.895 5.93977 15.8067C5.78849 15.6972 5.75 15.6045 5.75 15Z"
                fill="#28AF60"
              />
              <path
                d="M19 12.75C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H19Z"
                fill="#28AF60"
              />
              <path
                d="M19.75 9C19.75 9.41422 19.4142 9.75 19 9.75H14C13.5858 9.75 13.25 9.41422 13.25 9C13.25 8.58579 13.5858 8.25 14 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9Z"
                fill="#28AF60"
              />
              <path
                d="M19 15.75C19.4142 15.75 19.75 15.4142 19.75 15C19.75 14.5858 19.4142 14.25 19 14.25H16C15.5858 14.25 15.25 14.5858 15.25 15C15.25 15.4142 15.5858 15.75 16 15.75H19Z"
                fill="#28AF60"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.94358 3.25H14.0564C15.8942 3.24998 17.3498 3.24997 18.489 3.40314C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33856 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V12.0564C22.75 13.8942 22.75 15.3498 22.5969 16.489C22.4392 17.6614 22.1071 18.6104 21.3588 19.3588C20.6104 20.1071 19.6614 20.4392 18.489 20.5969C17.3498 20.75 15.8942 20.75 14.0565 20.75H9.94359C8.10585 20.75 6.65018 20.75 5.51098 20.5969C4.33856 20.4392 3.38961 20.1071 2.64124 19.3588C1.89288 18.6104 1.56076 17.6614 1.40314 16.489C1.24997 15.3498 1.24998 13.8942 1.25 12.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40314C6.65019 3.24997 8.10583 3.24998 9.94358 3.25ZM5.71085 4.88976C4.70476 5.02503 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02503 6.70476 2.88976 7.71085C2.75159 8.73851 2.75 10.0932 2.75 12C2.75 13.9068 2.75159 15.2615 2.88976 16.2892C3.02503 17.2952 3.27869 17.8749 3.7019 18.2981C4.12511 18.7213 4.70476 18.975 5.71085 19.1102C6.73851 19.2484 8.09318 19.25 10 19.25H14C15.9068 19.25 17.2615 19.2484 18.2892 19.1102C19.2952 18.975 19.8749 18.7213 20.2981 18.2981C20.7213 17.8749 20.975 17.2952 21.1102 16.2892C21.2484 15.2615 21.25 13.9068 21.25 12C21.25 10.0932 21.2484 8.73851 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02503 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976Z"
                fill="#28AF60"
              />
            </svg>
            <div className="font-[700] text-[14px] font-[cairo] ">
              المعلومات الشخصية
            </div>
          </div>
          <div className="flex items-center justify-start gap-[20px] mt-[4px] ">
            <span>العمر :</span>
            <span>{trainerData.age}</span>
          </div>
          <div className="flex items-center justify-start gap-[20px] ">
            <span>الجنسية :</span>
            <span>{trainerData.country_id}</span>
          </div>
          <div className="flex items-center justify-start gap-[20px] ">
            <span>مكان التواجد :</span>
            <span>{trainerData.country_id}</span>
          </div>
        </div>

        <div className=" flex flex-col w-full sm:w-[calc(100%-250px)]   ">
          <div className="main-shadow flex flex-col border border-[#F1F1F2] p-[13px] rounded-[20px] w-full gap-[15px] ">
            <div className="flex items-center justify-start gap-[10px]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.217 3.49965C12.796 2.83345 11.2035 2.83345 9.78252 3.49965L5.48919 5.51246C6.27114 5.59683 6.98602 6.0894 7.31789 6.86377C7.80739 8.00594 7.2783 9.32867 6.13613 9.81817L5.06046 10.2792C4.52594 10.5082 4.22261 10.6406 4.01782 10.7456C4.0167 10.7619 4.01564 10.7788 4.01465 10.7962L9.78261 13.5003C11.2036 14.1665 12.7961 14.1665 14.2171 13.5003L20.9082 10.3634C22.3637 9.68105 22.3637 7.31899 20.9082 6.63664L14.217 3.49965Z"
                  fill="#28AF60"
                />
                <path
                  d="M4.9998 12.9147V16.6254C4.9998 17.6334 5.50331 18.5772 6.38514 19.0656C7.85351 19.8787 10.2038 21 11.9998 21C13.7958 21 16.1461 19.8787 17.6145 19.0656C18.4963 18.5772 18.9998 17.6334 18.9998 16.6254V12.9148L14.8538 14.8585C13.0294 15.7138 10.9703 15.7138 9.14588 14.8585L4.9998 12.9147Z"
                  fill="#28AF60"
                />
                <path
                  d="M5.54544 8.43955C5.92616 8.27638 6.10253 7.83547 5.93936 7.45475C5.7762 7.07403 5.33529 6.89767 4.95456 7.06083L3.84318 7.53714C3.28571 7.77603 2.81328 7.97849 2.44254 8.18705C2.04805 8.40898 1.70851 8.66944 1.45419 9.05513C1.19986 9.44083 1.09421 9.85551 1.04563 10.3055C0.999964 10.7284 0.999981 11.2424 1 11.8489V14.7502C1 15.1644 1.33579 15.5002 1.75 15.5002C2.16422 15.5002 2.5 15.1644 2.5 14.7502V11.8878C2.5 11.232 2.50101 10.7995 2.53696 10.4665C2.57095 10.1517 2.63046 9.99612 2.70645 9.88087C2.78244 9.76562 2.90202 9.64964 3.178 9.49438C3.46985 9.33019 3.867 9.15889 4.46976 8.90056L5.54544 8.43955Z"
                  fill="#28AF60"
                />
              </svg>
              <div className="font-[700] text-[14px] font-[cairo] ">
                المؤهلات
              </div>
            </div>
            <div className="w-full flex flex-wrap items-stretch justify-center gap-[clamp(5px,1.7361111111111112vw,25px)] ">
              {trainerData?.qualifications?.map((item) => {
                return (
                  <div className="flex w-[48%] sm:w-[162px] flex-col border border-[#F1F1F2] rounded-[8px] p-[3px]  ">
                    <img
                      className="rounded-[8px] "
                      src={
                        item.image ||
                        "https://via.assets.so/img.jpg?w=155&h=111&tc=blue&bg=#C4C4C4"
                      }
                      alt="trainer image"
                    />
                    <div className="w-full text-center py-[5px] font-[cairo] font-[700] text-[12px] leading-[23px] ">
                      {item.title}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="main-shadow flex flex-col border border-[#F1F1F2] mt-[20px] p-[13px] rounded-[20px] w-full gap-[25px] ">
            <div className="flex w-full items-center justify-start gap-[10px]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 4.5C17 5.88071 15.8807 7 14.5 7C13.1193 7 12 5.88071 12 4.5C12 3.11929 13.1193 2 14.5 2C15.8807 2 17 3.11929 17 4.5Z"
                  fill="#28AF60"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.3633 10.3459C13.8381 11.0937 14.0951 12.1104 14.0951 13.4343C14.0951 18.5171 10.1339 22.75 5 22.75C4.58579 22.75 4.25 22.4142 4.25 22C4.25 21.5858 4.58579 21.25 5 21.25C9.2549 21.25 12.5951 17.7402 12.5951 13.4343C12.5951 12.2909 12.3715 11.5823 12.097 11.1498C11.8323 10.733 11.4884 10.5209 11.116 10.4217C10.726 10.3177 10.2869 10.3349 9.87888 10.4244C9.46283 10.5156 9.15214 10.6655 9.02681 10.7544C8.70695 10.981 8.38076 11.4084 8.24551 11.8566C8.11753 12.2806 8.18065 12.6163 8.44446 12.8713C8.44446 12.8713 8.44447 12.8713 8.44446 12.8713L8.46924 12.8952C8.7671 13.1831 8.77522 13.6579 8.48738 13.9557C8.19954 14.2536 7.72473 14.2617 7.42687 13.9739L7.40209 13.9499C6.62406 13.198 6.56874 12.2209 6.80948 11.4232C7.04295 10.6496 7.57265 9.94634 8.15959 9.53045C8.48766 9.298 8.99767 9.08198 9.55761 8.9592C10.1256 8.83466 10.8178 8.78978 11.5024 8.9723C12.2047 9.15952 12.8787 9.58251 13.3633 10.3459ZM15.5072 14.4639C17.7239 14.1069 19.75 15.8031 19.75 18.0486V21.9957C19.75 22.4099 19.4142 22.7457 19 22.7457C18.5858 22.7457 18.25 22.4099 18.25 21.9957V18.0486C18.25 16.7424 17.0661 15.7322 15.7458 15.9449C15.3368 16.0107 14.9519 15.7326 14.886 15.3237C14.8202 14.9147 15.0983 14.5298 15.5072 14.4639Z"
                  fill="#28AF60"
                />
              </svg>
              <div className="font-[700] text-[14px] font-[cairo] ">
                الخبرات العملية
              </div>
            </div>
            <div className="gap-[15px] flex items-start flex-col w-full justify-between">
              {trainerData?.experience?.map((item) => {
                return (
                  <div className="main-shadow flex flex-col sm:flex-row items-center justify-between gap-[5px] border border-[#F1F1F2] p-[10px] rounded-[12px] w-full ">
                    <div className="font-[cairo] font-[700] text-[clamp(9px,0.8334vw,12px)">
                      {item.exp_name}
                    </div>
                    <div className="font-[cairo] text-[#767676] font-[700] text-[clamp(9px,0.8334vw,12px)">
                      {item.exp_time}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="main-shadow flex flex-col border border-[#F1F1F2] mt-[20px] p-[13px] rounded-[20px] w-full gap-[25px] ">
            <div className="flex w-full items-center justify-start gap-[10px]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.54 11.41L15.22 9V11.45L13.54 11.41ZM21 4.87V15.87C21 16.2535 20.9245 16.6332 20.7777 16.9874C20.631 17.3417 20.4159 17.6636 20.1448 17.9348C19.8736 18.2059 19.5517 18.421 19.1974 18.5677C18.8432 18.7145 18.4635 18.79 18.08 18.79H17C16.7012 18.7893 16.4053 18.8492 16.1303 18.9661C15.8553 19.0829 15.6069 19.2544 15.4 19.47L13.59 21.37C13.3817 21.5887 13.1312 21.7629 12.8536 21.8819C12.5759 22.0009 12.277 22.0623 11.975 22.0623C11.673 22.0623 11.3741 22.0009 11.0964 21.8819C10.8188 21.7629 10.5683 21.5887 10.36 21.37L8.69 19.5C8.48305 19.2743 8.23106 19.0944 7.95029 18.9721C7.66953 18.8499 7.36624 18.7878 7.06 18.79H5.92C5.14557 18.79 4.40285 18.4824 3.85525 17.9348C3.30764 17.3871 3 16.6444 3 15.87V4.87C3.01311 4.10427 3.32654 3.37433 3.87273 2.8375C4.41892 2.30066 5.15415 1.99989 5.92 2H18.08C18.8458 1.99989 19.5811 2.30066 20.1273 2.8375C20.6735 3.37433 20.9869 4.10427 21 4.87ZM7.93 12.87C8.16 12.66 8.46 12.43 8.77 12.19C9.85 11.35 11.07 10.4 11.08 9.04C11.08 8.40348 10.8271 7.79303 10.3771 7.34294C9.92697 6.89286 9.31652 6.64 8.68 6.64C8.04348 6.64 7.43303 6.89286 6.98294 7.34294C6.53286 7.79303 6.28 8.40348 6.28 9.04C6.28 9.23891 6.35902 9.42968 6.49967 9.57033C6.64032 9.71098 6.83109 9.79 7.03 9.79C7.22891 9.79 7.41968 9.71098 7.56033 9.57033C7.70098 9.42968 7.78 9.23891 7.78 9.04C7.78 8.80131 7.87482 8.57239 8.0436 8.4036C8.21239 8.23482 8.44131 8.14 8.68 8.14C8.80112 8.13562 8.92189 8.15548 9.03522 8.19841C9.14856 8.24134 9.25218 8.30648 9.34 8.39C9.49557 8.55484 9.58154 8.77335 9.58 9C9.58 9.63 8.58 10.38 7.85 11C7.38428 11.3338 6.95223 11.7123 6.56 12.13C6.38854 12.323 6.27648 12.5614 6.23728 12.8165C6.19809 13.0717 6.23343 13.3327 6.33906 13.5683C6.44468 13.8038 6.6161 14.0039 6.8327 14.1443C7.0493 14.2848 7.30185 14.3597 7.56 14.36H10.33C10.5289 14.36 10.7197 14.281 10.8603 14.1403C11.001 13.9997 11.08 13.8089 11.08 13.61C11.08 13.4111 11.001 13.2203 10.8603 13.0797C10.7197 12.939 10.5289 12.86 10.33 12.86L7.93 12.87ZM17.85 12.21C17.85 12.0111 17.771 11.8203 17.6303 11.6797C17.4897 11.539 17.2989 11.46 17.1 11.46H16.7V7.96C16.7045 7.70816 16.627 7.46168 16.479 7.25782C16.3311 7.05396 16.1208 6.90379 15.88 6.83C15.6398 6.7544 15.3816 6.75833 15.1438 6.8412C14.9059 6.92408 14.7012 7.08147 14.56 7.29L12 11.07C11.8768 11.2452 11.805 11.4513 11.7927 11.665C11.7803 11.8788 11.8279 12.0918 11.93 12.28C12.0249 12.465 12.1678 12.6211 12.3437 12.7319C12.5197 12.8427 12.7222 12.9043 12.93 12.91H15.2V13.57C15.1987 13.668 15.2168 13.7653 15.2534 13.8563C15.29 13.9472 15.3443 14.03 15.4132 14.0997C15.482 14.1695 15.564 14.2249 15.6545 14.2627C15.7449 14.3005 15.842 14.32 15.94 14.32C16.1372 14.32 16.3265 14.2424 16.4668 14.1039C16.6072 13.9654 16.6874 13.7772 16.69 13.58V12.91H17.1C17.2989 12.91 17.4897 12.831 17.6303 12.6903C17.771 12.5497 17.85 12.3589 17.85 12.16V12.21Z"
                  fill="#28AF60"
                />
              </svg>

              <div className="font-[700] text-[14px] font-[cairo] ">خدماتي</div>
            </div>
            <div className="gap-[10px] flex items-center sm:items-start flex-wrap w-full justify-center sm:justify-start">
              {trainerData?.services?.map((item) => {
                return (
                  <div className="main-shadow flex items-center justify-between border border-[#F1F1F2] py-[10px] px-[12px] rounded-[12px] w-fit ">
                    <div>{item}</div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="main-shadow flex flex-col border border-[#F1F1F2] mt-[20px] p-[13px] rounded-[20px] w-full gap-[25px] ">
            <div className="flex w-full items-center justify-start gap-[10px]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.71 2H8.22001C7.40028 1.99866 6.5884 2.15963 5.83119 2.47362C5.07398 2.78761 4.38643 3.24841 3.80819 3.82944C3.22995 4.41046 2.77247 5.10022 2.46213 5.85893C2.15179 6.61764 1.99473 7.43029 2.00001 8.25V15.71C1.99474 16.5316 2.15152 17.3462 2.46138 18.1071C2.77123 18.8681 3.22809 19.5605 3.8058 20.1447C4.38351 20.7289 5.07075 21.1935 5.82819 21.5118C6.58562 21.8302 7.3984 21.9961 8.22001 22H15.71C17.3774 21.9974 18.9758 21.3338 20.1548 20.1548C21.3338 18.9758 21.9974 17.3774 22 15.71V8.25C21.9974 7.42661 21.8326 6.6118 21.5151 5.85209C21.1976 5.09239 20.7335 4.40266 20.1494 3.82229C19.5654 3.24192 18.8727 2.78228 18.111 2.46961C17.3492 2.15695 16.5334 1.99737 15.71 2ZM15.58 12C15.58 12.7177 15.3666 13.4191 14.967 14.0153C14.5675 14.6114 13.9997 15.0753 13.3359 15.3481C12.6721 15.6209 11.9422 15.6902 11.2389 15.5472C10.5357 15.4043 9.89074 15.0555 9.3861 14.5452C8.88146 14.035 8.53988 13.3862 8.40476 12.6814C8.26963 11.9766 8.34705 11.2475 8.62718 10.5867C8.90731 9.92602 9.37752 9.36346 9.97806 8.97054C10.5786 8.57762 11.2824 8.37207 12 8.38C12.4728 8.38262 12.9404 8.47833 13.3762 8.66167C13.8119 8.84502 14.2073 9.11239 14.5397 9.44854C14.8722 9.78469 15.1352 10.183 15.3136 10.6208C15.4921 11.0586 15.5826 11.5272 15.58 12ZM17.85 7.14C17.6522 7.14 17.4589 7.08135 17.2944 6.97147C17.13 6.86159 17.0018 6.70541 16.9261 6.52269C16.8504 6.33996 16.8306 6.13889 16.8692 5.94491C16.9078 5.75093 17.003 5.57275 17.1429 5.43289C17.2828 5.29304 17.4609 5.1978 17.6549 5.15922C17.8489 5.12063 18.05 5.14043 18.2327 5.21612C18.4154 5.29181 18.5716 5.41998 18.6815 5.58443C18.7914 5.74888 18.85 5.94222 18.85 6.14C18.8448 6.40174 18.7371 6.65098 18.5501 6.83421C18.3632 7.01745 18.1118 7.12005 17.85 7.12V7.14Z"
                  fill="#28AF60"
                />
              </svg>

              <div className="font-[700] text-[14px] font-[cairo] ">
                معرض صورالكابتن
              </div>
            </div>
            <div class="w-full  ">
              <Swiper
                modules={[Pagination, A11y, Autoplay]}
                centeredSlides={true}
                pagination={{ clickable: true }}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop={true}
                dir="rtl"
                direction="horizontal"
                className="w-full max-w-[1060px] rounded-[clamp(15px,1.1979166666666667vw,23px)] academySwiper"
              >
                {trainerData?.images?.map((slide) => {
                  return (
                    <SwiperSlide key={slide.id}>
                      <a className="w-full  " href="#">
                        <img
                          src={
                            slide.image ||
                            `https://via.assets.so/img.jpg?w=1060&h=339`
                          }
                          alt="academy slider slide"
                          loading="lazy"
                          className="w-full "
                        />
                      </a>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>

          {/* user social */}
          <div className="w-full mt-[50px] p-[13px] rounded-[20px] flex items-center justify-center px-[10px] gap-[8px] ">
            {/* instagram */}
            <a
              href={trainerData.instagram || "https://instagram.com"}
              target="_blank"
              className="w-[44px] h-[clamp(35px,2.291vw,44px)] flex items-center justify-center rounded-[8px] "
              style={{
                background:
                  "linear-gradient(45deg, #FAAD4F 14.61%, #DD2A7B 39.38%, #9537B0 58.49%, #515BD4 85.39%)",
                backgroundPosition: "center center",
                boxShadow: "0px 3px 4px 0px #00000008",
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.8444 0.716187H5.16044C2.48507 0.716187 0.308594 2.8933 0.308594 5.56946V14.4315C0.308594 17.1076 2.48507 19.2847 5.16044 19.2847H14.8444C17.5197 19.2847 19.6962 17.1076 19.6962 14.4315V5.56946C19.6962 2.8933 17.5197 0.716187 14.8444 0.716187ZM2.02017 5.56946C2.02017 3.83764 3.42912 2.42827 5.16044 2.42827H14.8444C16.5757 2.42827 17.9846 3.83764 17.9846 5.56946V14.4315C17.9846 16.1633 16.5757 17.5727 14.8444 17.5727H5.16044C3.42912 17.5727 2.02017 16.1633 2.02017 14.4315V5.56946Z"
                  fill="white"
                />
                <path
                  d="M10.0033 14.5137C12.4911 14.5137 14.5163 12.4891 14.5163 9.99935C14.5163 7.50965 12.4922 5.48499 10.0033 5.48499C7.51431 5.48499 5.49023 7.50965 5.49023 9.99935C5.49023 12.4891 7.51431 14.5137 10.0033 14.5137ZM10.0033 7.19816C11.5482 7.19816 12.8047 8.45508 12.8047 10.0004C12.8047 11.5458 11.5482 12.8027 10.0033 12.8027C8.45836 12.8027 7.20181 11.5458 7.20181 10.0004C7.20181 8.45508 8.45836 7.19816 10.0033 7.19816Z"
                  fill="white"
                />
                <path
                  d="M14.9328 6.21441C15.6027 6.21441 16.1487 5.6693 16.1487 4.99807C16.1487 4.32684 15.6038 3.78174 14.9328 3.78174C14.2617 3.78174 13.7168 4.32684 13.7168 4.99807C13.7168 5.6693 14.2617 6.21441 14.9328 6.21441Z"
                  fill="white"
                />
              </svg>
            </a>

            {/* facebook */}
            <a
              href={trainerData.facebook || "https://facebook.com"}
              target="_blank"
              className="w-[44px] h-[clamp(35px,2.291vw,44px)] flex items-center justify-center rounded-[8px] bg-[#1877F2] "
              style={{
                boxShadow: "0px 3px 4px 0px #00000008",
              }}
            >
              <svg
                width="12"
                height="20"
                viewBox="0 0 12 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.80117 4.50662V7.32631H11.2883L10.7361 11.1246H7.80117V19.8757C7.21273 19.9574 6.6107 20 5.9996 20C5.2942 20 4.6015 19.9438 3.92693 19.8349V11.1246H0.710938V7.32631H3.92693V3.87629C3.92693 1.73589 5.66141 0 7.80208 0V0.00181359C7.80842 0.00181359 7.81386 0 7.82021 0H11.2892V3.28496H9.02247C8.3488 3.28496 7.80208 3.83185 7.80208 4.50571L7.80117 4.50662Z"
                  fill="white"
                />
              </svg>
            </a>

            {/* whatsapp */}
            <a
              href={
                `https://wa.me/${trainerData?.whatsapp_number}` || "https://wa.me/4915252455276"
              }
              target="_blank"
              className="w-[clamp(140px,8.69791vw,167px)] h-[clamp(35px,2.291vw,44px)] flex items-center justify-center gap-[5px] rounded-[8px] bg-[#28AF60] "
              style={{
                boxShadow: "0px 3px 4px 0px #00000008",
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.2596 0.880136C10.3258 0.471247 10.7124 0.193872 11.1212 0.26007C11.1466 0.264914 11.228 0.280135 11.2707 0.289637C11.356 0.308641 11.475 0.337899 11.6234 0.381124C11.9202 0.467567 12.3348 0.609972 12.8324 0.838108C13.8287 1.29486 15.1545 2.09387 16.5303 3.46967C17.9061 4.84547 18.7051 6.17128 19.1619 7.16756C19.39 7.66517 19.5324 8.07978 19.6188 8.37656C19.6621 8.52496 19.6913 8.64399 19.7103 8.72932C19.7198 8.77199 19.7268 8.80625 19.7316 8.83156L19.7374 8.86275C19.8036 9.27164 19.5287 9.67416 19.1198 9.74036C18.7121 9.80637 18.328 9.53033 18.2602 9.12336C18.2581 9.11244 18.2524 9.08308 18.2462 9.05539C18.2339 9.00001 18.2125 8.91218 18.1787 8.79603C18.111 8.56369 17.9935 8.21836 17.7983 7.79268C17.4085 6.94238 16.7075 5.76819 15.4696 4.53033C14.2318 3.29247 13.0576 2.59147 12.2073 2.20164C11.7816 2.00648 11.4363 1.88895 11.2039 1.82128C11.0878 1.78745 10.9418 1.75394 10.8864 1.7416C10.4794 1.67378 10.1936 1.28786 10.2596 0.880136Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.4859 4.3296C10.5997 3.93133 11.0148 3.70071 11.413 3.8145L11.207 4.53564C11.413 3.8145 11.413 3.8145 11.413 3.8145L11.4145 3.81491L11.416 3.81536L11.4194 3.81633L11.4271 3.81864L11.4469 3.82481C11.462 3.82963 11.4808 3.83591 11.5033 3.84388C11.5482 3.85981 11.6075 3.88248 11.6803 3.91368C11.826 3.97612 12.0251 4.07254 12.2696 4.21725C12.7591 4.50693 13.4272 4.98811 14.2122 5.77308C14.9972 6.55805 15.4784 7.22624 15.768 7.7157C15.9128 7.96021 16.0092 8.15928 16.0716 8.30496C16.1028 8.37777 16.1255 8.43713 16.1414 8.48204C16.1494 8.50449 16.1557 8.52332 16.1605 8.5384L16.1666 8.55818L16.169 8.56594L16.1699 8.56927L16.1704 8.5708C16.1704 8.5708 16.1708 8.57224 15.4496 8.77828L16.1708 8.57224C16.2846 8.97052 16.054 9.38563 15.6557 9.49943C15.2608 9.61225 14.8493 9.38649 14.7315 8.99443L14.7278 8.98365C14.7224 8.96863 14.7114 8.93904 14.6929 8.89584C14.6559 8.80951 14.5888 8.66827 14.4772 8.47968C14.2542 8.10294 13.8515 7.53369 13.1516 6.83374C12.4516 6.13379 11.8823 5.73108 11.5056 5.50811C11.317 5.3965 11.1758 5.3294 11.0894 5.2924C11.0462 5.27388 11.0167 5.26285 11.0016 5.25752L10.9909 5.25382C10.5988 5.13594 10.373 4.7245 10.4859 4.3296Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.00745 3.4069C3.68752 1.72683 6.52266 1.85455 7.69248 3.95067L8.34149 5.1136C9.10541 6.48242 8.77987 8.2095 7.66157 9.34147C7.64668 9.36188 7.56774 9.47681 7.55791 9.67762C7.54536 9.93394 7.63639 10.5267 8.55482 11.4452C9.47295 12.3633 10.0656 12.4545 10.3221 12.4421C10.5231 12.4323 10.6381 12.3533 10.6585 12.3384C11.7905 11.2201 13.5176 10.8946 14.8864 11.6585L16.0493 12.3075C18.1454 13.4773 18.2731 16.3125 16.5931 17.9925C15.6944 18.8912 14.4995 19.6897 13.0953 19.7429C11.0144 19.8218 7.55913 19.2844 4.13735 15.8626C0.715564 12.4408 0.178177 8.9856 0.257065 6.90467C0.310297 5.50048 1.10879 4.30556 2.00745 3.4069ZM6.38265 4.68167C5.78363 3.60832 4.17394 3.36173 3.06811 4.46756C2.29276 5.24291 1.7887 6.09872 1.75599 6.9615C1.6902 8.69684 2.11864 11.7226 5.19801 14.802C8.27737 17.8813 11.3031 18.3098 13.0385 18.244C13.9013 18.2113 14.7571 17.7072 15.5324 16.9319C16.6382 15.826 16.3916 14.2163 15.3183 13.6173L14.1554 12.9683C13.432 12.5646 12.4158 12.7023 11.7025 13.4156C11.6325 13.4856 11.1864 13.9018 10.395 13.9403C9.58474 13.9797 8.604 13.6157 7.49416 12.5058C6.38395 11.3956 6.02003 10.4146 6.0597 9.60427C6.09846 8.81275 6.51468 8.36715 6.58432 8.2975C7.29764 7.58418 7.43539 6.56801 7.03166 5.8446L6.38265 4.68167Z"
                  fill="white"
                />
              </svg>
              <span className="font-[Cairo] text-[clamp(10px,0.625vw,12px)] font-[600] leading-[clamp(15px,1.1458vw,22px)] text-[#fff]">
                {currentLang.contactInstitutions}
              </span>
            </a>

            {/* share */}
            <div
              onClick={() => {
                copyToClipboard(window.location.href);
                toast.success("Link copied to clipboard");
              }}
              className="w-[66px] h-[clamp(35px,2.291vw,44px)] flex items-center justify-center rounded-[8px] border border-[#28AF6080] "
              style={{
                boxShadow: "0px 3px 4px 0px #00000008",
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 12C9 13.3807 7.88071 14.5 6.5 14.5C5.11929 14.5 4 13.3807 4 12C4 10.6193 5.11929 9.5 6.5 9.5C7.88071 9.5 9 10.6193 9 12Z"
                  stroke="#44A853"
                  stroke-width="1.5"
                />
                <path
                  d="M14 6.5L9 10"
                  stroke="#44A853"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M14 17.5L9 14"
                  stroke="#44A853"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M19 18.5C19 19.8807 17.8807 21 16.5 21C15.1193 21 14 19.8807 14 18.5C14 17.1193 15.1193 16 16.5 16C17.8807 16 19 17.1193 19 18.5Z"
                  stroke="#44A853"
                  stroke-width="1.5"
                />
                <path
                  d="M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5Z"
                  stroke="#44A853"
                  stroke-width="1.5"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Trainer;
